import { RemoteParamKeys, useToggle } from '@/lib/firebase/hooks'
/**
 * This hook is being used to determine if we should show the new design of the mweb SRP developed in KJCA-4733
 * Due to the SEO version of the SRP, we only want this toggle to return true if it is enabled
 * For more info please refer to: https://jira.ets.mpi-internal.com/browse/KJCA-4733
 */
export const useSrpMwebRedesign = () => {
  const isSrpControlsMwebToggleEnabled =
    useToggle(RemoteParamKeys.SRP_CONTROLS_MWEB_REDESIGN)?.enabled ?? false

  return isSrpControlsMwebToggleEnabled
}
